// Preserve the existing CANZA release hold without emptying unrelated projects.
// This is a presentation hold; API authorization remains the server's responsibility.
export function isMarketplaceProjectVisible(project) {
  return !/\bcanza\b/i.test(project?.name || "");
}
